import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
} from "react-native";
import React, { useState } from "react";
import { observer, Observer } from "mobx-react";
import GlobalStyles from "../../../Resources/Styles";

import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import { Ionicons } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import { Menu, MenuItem } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../../_layout";
import CustomAlert from "../../Components/CustomAlert";
import { useTranslation } from "react-i18next";
import WorkoutDescriptionView from "../../Workout/WorkoutDescriptionView";
import AddWorkoutView from "../../Workout/AddWorkoutView";
import IconEmptyView from "../../Components/IconEmptyView";
import SearchBar from "../../Components/SearchBar";
import CTAButton from "../../Components/CTAButton";
import InfoView from "../../Block/InfoView";
import BackButton from "../../Components/BackButton";
import EditWorkoutView from "../../Workout/EditWorkoutView";
import TutorialLinkSection from "../../Components/TutorialLinkSection";

const WorkoutLibrary = ({ coach }) => {
  const { t, i18n } = useTranslation();

  const [showingAddNewWorkout, setShowingAddNewWorkout] = useState(false);
  const { screenSize } = useScreenDimensions();

  const { isMobile } = useDevice();

  const WorkoutRow = observer(({ workout }) => {
    const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
    const deleteAlertTitle = "deleteWorkoutAlertTitle-string";
    const deleteAlertText = "deleteWorkoutAlertText-string";

    const [showingChangeWorkoutName, setShowingChangeWorkoutName] =
      useState(false);

    const [workoutMenu, setWorkoutMenu] = useState(false);
    const showWorkoutMenu = () => setWorkoutMenu(true);

    const action = () => {
      workout.setProperty("isSelected", true);
    };

    const showDeleteAlert = () => {
      setShowingDeleteAlert(true);
      setWorkoutMenu(false);
    };
    const showChangeName = () => {
      setShowingChangeWorkoutName(true);
      setWorkoutMenu(false);
    };
    const deleteLibraryWorkout = () => {
      if (workout.coach) {
        workout.coach.updateCoachDeletionWorkouts(workout.id);
        workout.coach.startOrResetBatchTimer();
      }

      coach.setProperty(
        "workoutLibrary",
        (coach.workoutLibrary = coach.workoutLibrary.filter(
          (w) => w.id !== workout.id
        ))
      );
      setWorkoutMenu(false);
    };

    const [isHovered, setIsHovered] = useState(false);
    const [isMenuHovered, setIsMenuHovered] = useState(false);

    const MenuItemView = ({ idx }) => {
      const [isHovered, setIsHovered] = useState(false);

      return idx === 1 ? (
        <MenuItem
          onPress={showChangeName}
          style={{ minWidth: 150 }}
          textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("changeName-string")}
        </MenuItem>
      ) : (
        <MenuItem
          onPress={showDeleteAlert}
          style={{ minWidth: 150 }}
          textStyle={{
            fontSize: 14,
            color: "red",
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("delete-string")}
        </MenuItem>
      );
    };

    return (
      <View
        style={{
          width: `calc((100% - ${screenSize === "small" ? 8 : 24}px) / ${
            screenSize === "small" ? 2 : 3
          })`,
        }}
      >
        <TouchableOpacity
          onPress={action}
          style={[
            GlobalStyles.touchableRow,
            {
              shadowColor: Colors.bubbleColor,
              borderWidth: 0.1,
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
            },
          ]}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              alignItems: "flex-start",
              justifyContent: "space-between",
              flex: 1,
              gap: 8,
            }}
          >
            <Text numberOfLines={2} style={[Fonts.medium14, { flexShrink: 1 }]}>
              {workout.name}
            </Text>
            <View style={GlobalStyles.HStack}>
              <FontAwesome5
                name="clipboard-list"
                size={12}
                color={Colors.bubbleColor}
                style={GlobalStyles.rowIcon}
              />
              <Text
                style={[GlobalStyles.rowSubText, { marginRight: 0 }]}
                numberOfLines={1}
              >
                {workout.exercises.length === 1
                  ? t("exerciseCountOne-string", {
                      count: workout.exercises.length,
                    })
                  : t("exerciseCount-string", {
                      count: workout.exercises.length,
                    })}
              </Text>
            </View>
          </View>

          <Menu
            visible={workoutMenu}
            anchor={
              <TouchableOpacity
                onPress={showWorkoutMenu}
                onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
                onMouseLeave={() => setIsMenuHovered(false)}
                style={{ marginLeft: 8 }}
              >
                <Entypo
                  name="dots-three-horizontal"
                  size={22}
                  color={isHovered || isMobile ? "black" : "transparent"}
                  style={{ opacity: isMenuHovered ? 0.5 : 1 }}
                />
              </TouchableOpacity>
            }
            style={GlobalStyles.menu}
            onRequestClose={() => setWorkoutMenu(false)}
          >
            <MenuItemView idx={1} />
            <MenuItemView idx={2} />
          </Menu>
        </TouchableOpacity>
        {showingDeleteAlert && (
          <CustomAlert
            isVisible={showingDeleteAlert}
            onClose={() => setShowingDeleteAlert(false)}
            title={deleteAlertTitle}
            text={deleteAlertText}
            action={deleteLibraryWorkout}
            specialCTA={"delete-string"}
          />
        )}
        {showingChangeWorkoutName && (
          <AddWorkoutView
            isVisible={showingChangeWorkoutName}
            onClose={() => setShowingChangeWorkoutName(false)}
            workout={workout}
          />
        )}
      </View>
    );
  });

  const LibraryWorkoutDescription = observer(({ workout }) => {
    const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
    const deleteAlertTitle = "deleteWorkoutAlertTitle-string";
    const deleteAlertText = "deleteWorkoutAlertText-string";

    const [showingChangeWorkoutName, setShowingChangeWorkoutName] =
      useState(false);

    const deleteLibraryWorkout = () => {
      if (workout.coach) {
        workout.coach.updateCoachDeletionWorkouts(workout.id);
        workout.coach.startOrResetBatchTimer();
      }
      coach.setProperty(
        "workoutLibrary",
        (coach.workoutLibrary = coach.workoutLibrary.filter(
          (w) => w.id !== workout.id
        ))
      );
    };

    const SideView = observer(() => {
      const [blockMenu, setBlockMenu] = useState(false);
      const showBlockMenu = () => setBlockMenu(true);

      const WorkoutNameHeader = observer(() => {
        const showChangeName = () => {
          setShowingChangeWorkoutName(true);
          setBlockMenu(false);
        };

        const showDeleteAlert = () => {
          setShowingDeleteAlert(true);
          setBlockMenu(false);
        };

        const [isMenuHovered, setIsMenuHovered] = useState(false);

        const MenuItemView = ({ idx }) => {
          const [isHovered, setIsHovered] = useState(false);

          return idx === 1 ? (
            <MenuItem
              onPress={showChangeName}
              style={{ minWidth: 150 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t("changeName-string")}
            </MenuItem>
          ) : (
            <MenuItem
              onPress={showDeleteAlert}
              style={{ minWidth: 150 }}
              textStyle={{
                fontSize: 14,
                color: "red",
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t("delete-string")}
            </MenuItem>
          );
        };
        return (
          <View
            style={{
              width: screenSize === "small" ? "auto" : "100%",
            }}
          >
            <View style={GlobalStyles.HStack}>
              <Text
                style={[Fonts.bold18, { flex: 1, marginRight: 10 }]}
                numberOfLines={3}
              >
                {workout.name}
              </Text>
              <Menu
                visible={blockMenu}
                anchor={
                  <TouchableOpacity
                    onPress={showBlockMenu}
                    onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
                    onMouseLeave={() => setIsMenuHovered(false)}
                  >
                    <Entypo
                      name="dots-three-horizontal"
                      size={24}
                      color="black"
                      style={{ opacity: isMenuHovered ? 0.5 : 1 }}
                    />
                  </TouchableOpacity>
                }
                style={GlobalStyles.menu}
                onRequestClose={() => setBlockMenu(false)}
              >
                <MenuItemView idx={1} />
                <MenuItemView idx={2} />
              </Menu>
            </View>
            <View
              style={{
                backgroundColor: Colors.blackColor,
                height: 1,
                opacity: 0.2,
                marginTop: 10,
              }}
            />
          </View>
        );
      });

      const TextNotes = () => {
        const [string, setString] = useState(
          workout.notes ? workout.notes : ""
        );

        const handleChange = (text) => {
          setString(text);
          workout.setProperty("notes", text);
        };

        const [isHovered, setIsHovered] = useState(false);

        return (
          <View
            style={{
              flex: 1,
              height: 40,
              marginLeft: screenSize === "large" ? 0 : 20,
            }}
          >
            <TextInput
              value={string}
              onChangeText={handleChange}
              multiline
              placeholder={t("notes-string")}
              placeholderTextColor={Colors.grayColor}
              numberOfLines={4} // Adjust as n
              style={{
                height: 100,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,

                fontSize: 14,
                padding: 8,
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            />
          </View>
        );
      };
      return (
        <View
          style={[
            screenSize != "large" && GlobalStyles.HStack,
            {
              width: screenSize === "large" ? "20%" : "100%",
              marginBottom: 20,
            },
          ]}
        >
          <TouchableOpacity
            onPress={() => workout.setProperty("isSelected", false)}
            style={{
              // flexDirection: "row",
              // alignItems: screenSize != "large" ? "baseline" : "center",
              marginBottom: screenSize != "large" ? 0 : 15,
              maxWidth: screenSize != "large" ? "50%" : "100%",
            }}
            disabled={screenSize != "small" ? true : false}
          >
            {screenSize != "small" && (
              <View style={{ marginBottom: 12 }}>
                <BackButton
                  action={() => workout.setProperty("isSelected", false)}
                  backString={t("back-string")}
                />
              </View>
            )}

            <WorkoutNameHeader />
          </TouchableOpacity>

          <TextNotes />
        </View>
      );
    });

    const PlanView = observer(() => {
      return (
        <View
          style={{
            flex: 1,
            marginRight:
              screenSize === "medium" ? 24 : screenSize === "large" ? 24 : 0,
            marginLeft: screenSize === "large" ? 24 : 0,
          }}
        >
          <View
            style={{
              backgroundColor: "white",
              borderRadius: 14,
              borderWidth: 0.1,
              borderColor: Colors.borderColor,
            }}
          >
            {coach.selectedWorkout.showingEditWorkout ? (
              <View style={{ paddingBottom: 0 }}>
                <EditWorkoutView
                  workout={coach.selectedWorkout}
                  coachLibrary={true}
                  coach={coach}
                />
              </View>
            ) : (
              <View style={{ paddingBottom: 0 }}>
                <WorkoutDescriptionView workout={coach.selectedWorkout} />
              </View>
            )}
          </View>
        </View>
      );
    });

    return (
      <View style={{ flex: 1, justifyContent: "space-between" }}>
        {screenSize !== "large" && <SideView />}

        <View
          style={{
            flexDirection: screenSize === "small" ? "column" : "row",
            flex: 1,
            justifyContent: "space-between",
          }}
        >
          {screenSize === "small" && (
            <>
              {coach.showingInfoView ? (
                <>
                  {/* <View style={{ marginBottom: 8 }}>
                    <BackButton
                      action={() => coach.setProperty("showingInfoView", false)}
                      backString={t("back-string")}
                    />
                  </View> */}

                  <InfoView
                    exercise={
                      coach.selectedWorkout.showingEditWorkout
                        ? coach.selectedWorkout.selectedExerciseToAdd
                        : coach.selectedWorkout.selectedExercise
                    }
                    coach={coach}
                    coachLibrary={true}
                    workoutView={true}
                  />
                </>
              ) : (
                <PlanView />
              )}
            </>
          )}

          {screenSize != "small" && (
            <>
              {screenSize === "large" && <SideView />}
              <PlanView />
              <View
                style={{
                  width: screenSize === "medium" ? "35%" : "25%",
                }}
              >
                <InfoView
                  exercise={
                    coach.selectedWorkout.showingEditWorkout
                      ? coach.selectedWorkout.selectedExerciseToAdd
                      : coach.selectedWorkout.selectedExercise
                  }
                  coach={coach}
                  coachLibrary={true}
                />
              </View>
            </>
          )}
        </View>

        {showingChangeWorkoutName && (
          <AddWorkoutView
            isVisible={showingChangeWorkoutName}
            onClose={() => setShowingChangeWorkoutName(false)}
            workout={workout}
          />
        )}
        {showingDeleteAlert && (
          <CustomAlert
            isVisible={showingDeleteAlert}
            onClose={() => setShowingDeleteAlert(false)}
            title={deleteAlertTitle}
            text={deleteAlertText}
            action={deleteLibraryWorkout}
            specialCTA={"delete-string"}
          />
        )}
      </View>
    );
  });

  return (
    <View
      style={[
        styles.container,
        { marginTop: screenSize === "small" ? 16 : 24 },
      ]}
    >
      <Observer>
        {() => (
          <>
            {coach.selectedWorkout ? (
              <LibraryWorkoutDescription workout={coach.selectedWorkout} />
            ) : (
              <>
                <View
                  style={[
                    GlobalStyles.HStack,
                    { marginBottom: 16, maxWidth: "45%" },
                  ]}
                >
                  <SearchBar
                    text={coach.searchTermWorkoutLibrary}
                    onChangeText={(text) =>
                      coach.setProperty("searchTermWorkoutLibrary", text)
                    }
                    placeholder={t("searchWorkout-string")}
                  />

                  <CTAButton
                    plus={true}
                    text={t("newWorkout-string")}
                    action={() => setShowingAddNewWorkout(true)}
                    disabled={false}
                  />
                </View>

                {coach.showWorkoutLibraryInfoView && (
                  <TutorialLinkSection
                    text="tutorialLibraryWorkouts-string"
                    urlPath="/library/workouts"
                    marginTop={8}
                    marginBottom={8}
                  />
                )}
                {coach.getFilteredWorkoutLibrary().length === 0 ? (
                  <IconEmptyView
                    iconLibrary={"Ionicons"}
                    mainText={"emptyWorkoutsTitle-string"}
                    subText={"createTemplateWorkoutsText-string"}
                    iconName={"folder-outline"}
                    marginTop={130}
                  />
                ) : (
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                      gap: screenSize === "small" ? 8 : 12,
                      marginTop: screenSize === "small" ? 0 : 8,
                    }}
                  >
                    {coach.getFilteredWorkoutLibrary().map((workout) => {
                      return <WorkoutRow workout={workout} key={workout.id} />;
                    })}
                  </View>
                )}

                {showingAddNewWorkout && (
                  <AddWorkoutView
                    isVisible={showingAddNewWorkout}
                    onClose={() => setShowingAddNewWorkout(false)}
                    coach={coach}
                  />
                )}
              </>
            )}
          </>
        )}
      </Observer>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
});

export default WorkoutLibrary;
